var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 0.707031C8.34485 0.707031 8.62467 0.986853 8.62467 1.33203V7.3737H14.6663C15.0115 7.3737 15.2913 7.65352 15.2913 7.9987C15.2913 8.34388 15.0115 8.6237 14.6663 8.6237H8.62467V14.6654C8.62467 15.0105 8.34485 15.2904 7.99967 15.2904C7.6545 15.2904 7.37467 15.0105 7.37467 14.6654V8.6237H1.33301C0.98783 8.6237 0.708008 8.34388 0.708008 7.9987C0.708008 7.65352 0.98783 7.3737 1.33301 7.3737H7.37467V1.33203C7.37467 0.986853 7.6545 0.707031 7.99967 0.707031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPlus);
export default __webpack_public_path__ + "static/media/ButtonPlus.ac04c2ff50474ceaa333c3375a8e4831.svg";
export { ForwardRef as ReactComponent };